import postal from 'postal';
import handleRoadblock from 'utils/handleRoadblock';

/*
  Call this method on a page that has mobile-roadblocked links or modals.
  Branch will be watching for us pushing the metadata that triggers a Journey show.
*/
function enableMobileRoadblock() {
  if (__AT_DATA__.mobileBrowser && global.branch) {
    const branchOptions = {
      disable_entry_animation: true,
      disable_exit_animation: true
    };

    global.branch.init(__AT_DATA__.BRANCH_KEY, branchOptions);
  }

  const messagingChannel = postal.channel('explore_messagingChannel');

  messagingChannel.subscribe('mobile_roadblock', (data: any) =>
    handleRoadblock({
      afterRoadblock: data.afterRoadblock,
      atRef: data.atRef,
      eventName: data.event,
      languageRegionCode: __AT_DATA__.languageRegionCode,
      openInNewTab: data.openInNewTab,
      returnToUrl: data.returnToUrl,
      user: data.currentUser
    })
  );
}

export default enableMobileRoadblock;
